import { PartnerRoles } from '../shared/generated';
export var getTripartiteCooperationMemberRoleMap = function getTripartiteCooperationMemberRoleMap() {
  return {
    partnerAdmin: {
      value: PartnerRoles.PARTNER_ADMIN,
      label: 'Admin'
    }
  };
};
export var getTripartiteCooperationMemberRoleList = function getTripartiteCooperationMemberRoleList() {
  return Object.values(getTripartiteCooperationMemberRoleMap());
};